import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseApiService } from '../../shared/base-service/base-api.service';
import { DriverDocumentRequirementSatisfyListViewModel } from '../models/requirement/driver-document-requirement-satisfy-list.model';
import { DriverRequirementDocumentApprovalList } from '../models/requirement/driver-requirement-document-approval-list.model';
import { DriverRequirementLookup } from '../models/requirement/driver-requirement-lookup.model';
import { DriverRequirementTypeDocumentTypeMapViewModel } from '../models/requirement/driver-requirement-type-document-type-map-view.model';
import { DriverRequirementTypeExaminationTypeMapViewModel } from '../models/requirement/driver-requirement-type-examination-type-map-view.model';
import { DriverRequirementsListViewModel } from '../models/requirement/driver-requirements-list-view.model';

@Injectable()
/**
 * CRUD actions related credential issuance requirements
*/
export class RequirementApplicationService extends BaseApiService {
    constructor() {
        super();
    }

    /**
     * Gets an up-to-date version of the application's categories and requirements
     * using the business transaction Id as the key
     * @param businessTransactionId
     */
    public getUpdatedDriverApplicationRequirements = (businessTransactionId: number): Observable<DriverRequirementsListViewModel> => this.post(`Driver/Requirement/Application/${businessTransactionId}`, null);

    /**
     * Gets requirements list and updates the statuses for each requirement
     * @param businessTransactionId
     */
    public getDriverApplicationRequirementsWithUpdatedStatuses = (businessTransactionId: number): Observable<DriverRequirementsListViewModel> => this.post(`Driver/Requirement/Application/Resolution/${businessTransactionId}`, null);

    /**
     * Gets lookups for requirements
     */
    public getLookups = (): Observable<DriverRequirementLookup> => this.get('Driver/Requirement/Lookups');

    /**
     * Saves requirement to document maping
     */
    public updateRequirementDocuments = (model: DriverDocumentRequirementSatisfyListViewModel): Observable<DriverRequirementsListViewModel> => this.post('Driver/Requirement/Satisfy/Document', model);

    /**
     * Saves requirement to document maping
     */
    public updateRequirementDocument = (businessTransactionNumberId: number, driverRequirementTypeId: number, documentData): Observable<DriverRequirementsListViewModel> => this.post('Driver/Requirement/Single/Satisfy/Document', { businessTransactionNumberId: businessTransactionNumberId, driverRequirementTypeId: driverRequirementTypeId, documentData: documentData });

    /**
     * Saves new requirement
     */
    public addNewRequirement = (businessTransactionId: number, requirementTypeId: number): Observable<DriverRequirementsListViewModel> => this.post('Driver/Requirement/Application/Requirement', { id: businessTransactionId, driverRequirementTypeId: requirementTypeId });

    /**
     * Updates requirements with document approval information
     */
    public updateRequirementDocumentApprovals = (model: DriverRequirementDocumentApprovalList): Observable<DriverRequirementDocumentApprovalList> => this.post('Driver/Requirement/Application/DocumentApproval', model);

    /**
     * Removes discretionary requirement
     */
    public removeDiscretionaryRequirement = (businessTransactionId: number, requirementTypeId: number): Observable<DriverRequirementsListViewModel> => this.delete(`Driver/Requirement/Application/${businessTransactionId}/Requirement/${requirementTypeId}`);

    /**
     * Gets requirement type to examination type mappings
     */
    public getDriverRequirementTypeExaminationTypeMap = (driverRequirementTypeId: number): Observable<DriverRequirementTypeExaminationTypeMapViewModel> => this.get(`Driver/Requirement/Examination/Types/${driverRequirementTypeId}`);

    /**
     * Gets requirement type to examination type mappings
     */
    public getDriverRequirementTypeExaminationTypeMaps = (): Observable<DriverRequirementTypeExaminationTypeMapViewModel> => this.get('Driver/Requirement/Examination/Types');

    /**
     * Gets requirement type to document type mappings
     */
    public getDriverRequirementTypeDocumentTypeMaps = (): Observable<DriverRequirementTypeDocumentTypeMapViewModel> => this.get('Driver/Requirement/Document/Types');
}
